import { render, staticRenderFns } from "./_base-order-label-creator.vue?vue&type=template&id=23ed8615"
import script from "./_base-order-label-creator.vue?vue&type=script&lang=js"
export * from "./_base-order-label-creator.vue?vue&type=script&lang=js"
import style0 from "./_base-order-label-creator.vue?vue&type=style&index=0&id=23ed8615&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports